import React from 'react'
import { Atividades } from '../../components/Atividades/Index.js'
import { Escolher } from '../../components/Escolher'
import { Slider } from '../../components/Slider/Index'
import { Gallery } from '../../components/Gallery'
import { Redes } from '../../components/Redes/index.js'
import { Form } from '../../components/Form/index.js'


export const Home = () => {
    return (
        <div>
            <Slider/>
            <Escolher/>
            <Atividades/>
            <Gallery/>
            <Redes/>
            <Form/>
        </div>
    )
}
